<template>
    <Upload :action="url" :on-success="onsuccess" :on-error="onerror">
        <Button icon="ios-cloud-upload-outline">Upload files</Button>
    </Upload>
</template>
<script>
    export default {
        data(){
			return{
				file:{
					name:'',
					url:''
				}
			}
		},
		props:["url"],
		methods:{
			onsuccess(response, file, fileList) {
				console.log(response)
				if(response.code==200){
					this.file.url=response.url
					this.file.name=response.name
					
					//向父组件传值
					
					this.$emit('file',this.file);
				}
			},
			onerror(){
				this.$Message.error('上传失败，请刷新后重试!');
			}
		}
		
    }
</script>



// WEBPACK FOOTER //
// src/components/comm/file.vue